import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys } from './helper'
import { httpPost, httpGet, httpPut } from '../core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { 
  homePath,
  reportRolesPath
} from 'routes'

const LOG_DOWNLOAD_BILLING_REPORT = 'LOG_DOWNLOAD_BILLING_REPORT'
const LOG_DOWNLOAD_GR_REPORT = 'LOG_DOWNLOAD_GR_REPORT'
const VALIDATE_ROLE_REPORT = makeKeys('VALIDATE_ROLE_REPORT')
const VALIDATE_ROLE_ADMIN_REPORT = 'VALIDATE_ROLE_ADMIN_REPORT'
const CREATE_ROLE_REPORT = 'CREATE_ROLE_REPORT'
const UPDATE_ROLE_REPORT = 'UPDATE_ROLE_REPORT'
const UPDATE_ROLE_DATA_TEMP = 'UPDATE_ROLE_DATA_TEMP'
const CLEAR_ROLE_DATA_TEMP = 'CLEAR_ROLE_DATA_TEMP'
const FETCH_REPORT_ROLES = makeKeys('FETCH_REPORT_ROLES')

export const logDownloadBillingReport = makeAction(LOG_DOWNLOAD_BILLING_REPORT)
export const logDownloadGRReport = makeAction(LOG_DOWNLOAD_GR_REPORT)
export const validateRoleReport = makeAction(VALIDATE_ROLE_REPORT.REQUEST, 'history')
export const validateRoleAdminReport = makeAction(VALIDATE_ROLE_ADMIN_REPORT, 'history')
export const createRoleReport = makeAction(CREATE_ROLE_REPORT, 'data','history')
export const updateRoleReport = makeAction(UPDATE_ROLE_REPORT, 'data','history')
export const updateRoleDataTemp = makeAction(UPDATE_ROLE_DATA_TEMP, 'data')
export const clearRoleDataTemp = makeAction(CLEAR_ROLE_DATA_TEMP,)
export const fetchReportRoles = makeAction(FETCH_REPORT_ROLES.REQUEST)

const fetchReportRolesSuccess = makeAction(FETCH_REPORT_ROLES.SUCCESS, 'data')
const validateRoleReportSuccess = makeAction(VALIDATE_ROLE_REPORT.SUCCESS, 'data')

function* logDownloadBillingReportRequest() {
  try {
    const response = yield httpPost('report/logDownloadBillingReport')
  } catch (e) {
  }
}

function* logDownloadGRReportRequest() {
  try {
    const response = yield httpPost('report/logDownloadGRReport')
  } catch (e) {
  }
}

function* validateRoleAdminReportRequest(action) {
  const { history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('report/validateAdmin')
    if (response.status >= 200 && response.status < 300) {
      if(!response.data){
        history.push(homePath)
        yield put(appLoaded())
      }else{
        yield put(appLoaded())
      }
    }
  } catch (e) {
    history.push(homePath)
    yield put(appLoaded())
  }
}

function* validateRoleReportRequest(action) {
  const { history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('report/validate')
    if (response.status >= 200 && response.status < 300) {
      if(!response.data){
        history.push(homePath)
        yield put(appLoaded())
      }else{
        let companyFilter = response.data.data
        if(!(companyFilter instanceof Object) && companyFilter){
          companyFilter = JSON.parse(companyFilter)
        }
        yield put(validateRoleReportSuccess(companyFilter))
        yield put(appLoaded())
      }
    }
  } catch (e) {
    history.push(homePath)
    yield put(appLoaded())
  }
}

function* fetchReportRolesRequest() {
  try {
    yield put(appLoading())
    const response = yield httpGet('report/roles')
    if (response.status >= 200 && response.status < 300) {
      yield put(fetchReportRolesSuccess(response.data))
      yield put(appLoaded())
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(fetchReportRolesSuccess([]))
  }
}

function* createRoleReportRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost('report/roles', data)
    if (response.status >= 200 && response.status < 300) {
      window.location.reload()
      yield put(toastSuccess('Create success'))
      yield put(appLoaded())
    }
  } catch (e) {
    if(e.data){
      yield put(toastError(e.data.message))
    }else{
      yield put(toastError('Create fail'))
    }
    yield put(appLoaded())
  }
}

function* updateRoleReportRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPut('report/roles', data)
    if (response.status >= 200 && response.status < 300) {
      window.location.reload()
      yield put(toastSuccess('Update success'))
      yield put(appLoaded())
    }
  } catch (e) {
    if(e.data){
      yield put(toastError(e.data.message))
    }else{
      yield put(toastError('Update fail'))
    }
    yield put(appLoaded())
  }
}

export function* watchReportSaga() {
  yield takeLatest(LOG_DOWNLOAD_BILLING_REPORT, logDownloadBillingReportRequest)
  yield takeLatest(LOG_DOWNLOAD_GR_REPORT, logDownloadGRReportRequest)
  yield takeLatest(VALIDATE_ROLE_REPORT.REQUEST, validateRoleReportRequest)
  yield takeLatest(VALIDATE_ROLE_ADMIN_REPORT, validateRoleAdminReportRequest)
  yield takeLatest(CREATE_ROLE_REPORT, createRoleReportRequest)
  yield takeLatest(UPDATE_ROLE_REPORT, updateRoleReportRequest)
  yield takeLatest(FETCH_REPORT_ROLES.REQUEST, fetchReportRolesRequest)
}

const initial = {
  reportRoles: [],
  roleDataTemp: {},
  companyFilter:[]
}

export default createReducer(initial, state => ({
  [FETCH_REPORT_ROLES.REQUEST]: () => ({
    ...state,
    reportRoles:[]
  }),
  [FETCH_REPORT_ROLES.SUCCESS]: (data) => ({
    ...state,
    reportRoles:data.data
  }),
  [VALIDATE_ROLE_REPORT.REQUEST]: () => ({
    ...state,
    companyFilter:[]
  }),
  [VALIDATE_ROLE_REPORT.SUCCESS]: (data) => ({
    ...state,
    companyFilter:data.data
  }),
  [UPDATE_ROLE_DATA_TEMP]: (data) => ({
    ...state,
    roleDataTemp:data.data
  }),
  [CLEAR_ROLE_DATA_TEMP]: (data) => ({
    ...state,
    roleDataTemp:{}
  }),
}))
